export default "__VITE_ASSET__Ckq0WZjE__"